import React from 'react';
import STypesTable from '../components/STypeTable';

export function STypes() {
  return <STypesTable />;
}
